import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export interface PropsType {
    state: FormInputState<boolean, boolean>,
    disabled?: boolean
}

export const Wrapper = styled('label', { label: 'Wrapper' })<Partial<PropsType>>`
    display: flex;
    align-items: center;
    opacity: ${({disabled}): number => disabled === true ? 0.4 : 1};
    pointer-events: ${({disabled}): string => disabled === true ? 'none' : 'auto'};
`;

export const SwitcherWrapper = styled('div', { label: 'SwitcherWrapper' })`
    position: relative;
    display: inline-block;
    width: 48px;
    height: 32px;
    flex: 0 1 auto;
    margin: 0 8px 0 0;
`;

export const Input = styled('input', { label: 'Input' })`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + span {
      background-color: ${mainColors.status.success};
    }

    &:focus + span {
      box-shadow: 0 0 1px ${mainColors.status.success};
    }

    &:checked + span:before {
      transform: translateX(16px);
    }
`;

export const Slider = styled('span', { label: 'Slider' })`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    transition: .4s;
    border-radius: 16px;
    box-sizing: border-box;
    border: 1px solid ${mainColors.grays.gray300};

    &:before {
        position: absolute;
        content: "";
        height: 32px;
        width: 32px;
        box-sizing: border-box;
        border: 1px solid ${mainColors.grays.gray300};
        left: -1px;
        bottom: -1px;
        background-color: ${mainColors.default.light};
        transition: .4s;
        border-radius: 50%;
    }
`;
